<!-- <template>
  <div class="input-group" :class="`input-group-${variant} ${getStatus(error, success)}`">
    <textarea :id="id || name" class="form-control border border-secondary rounded p-2" :rows="rows" :name="name" :value="value" :placeholder="placeholder"
      :disabled="disabled" :variant="variant" style="border: 1px solid lightgray;"
      @input="$emit('update:value', $event.target.value)" :required="isRequired" ></textarea>
  </div>
</template>

<script>
import setMaterialInput from "@/assets/js/material-input.js";

export default {
  name: "MaterialTextarea",
  props: {
    variant: {
      type: String,
      default: "outline",
    },
    id: {
      type: String,
      // required: true,
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Your text here...",
    },
    isRequired: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 5,
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    setMaterialInput();
  },
  methods: {
    getStatus: (error, success) => {
      let isValidValue;

      if (success) {
        isValidValue = "is-valid";
      } else if (error) {
        isValidValue = "is-invalid";
      } else {
        isValidValue = null;
      }

      return isValidValue;
    },
  },
};
</script> -->

<template>
  <label :class="[variant === 'static' ? '' : 'form-label', 'd-flex', 'align-items-center']" v-if="label">
    {{ label }}
    <span v-if="isRequired" class="text-danger">*</span>

    <Tooltip v-if="toolTipHeading && toolTipHeading != ''" :heading="toolTipHeading" :paragraph="toolTipDescription" />
  </label>
  <div class="input-group" :class="`input-group-${variant} ${statusClass}`">
    <textarea :id="id || name" class="form-control" :rows="rows" :name="name"
      v-model="localValue" :placeholder="placeholder" :disabled="disabled" :readonly="readOnly" :required="isRequired"
      :style="readOnly ? { backgroundColor: '#e9ecef', cursor: 'not-allowed', border: '1px solid lightgray' } : { border: '1px solid lightgray' }"></textarea>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted } from "vue"
import setMaterialInput from "@/assets/js/material-input.js"
import Tooltip from "./Tooltip.vue"

const props = defineProps({
  variant: {
    type: String,
    default: "outline",
  },
  id: String,
  name: {
    type: String,
    default: "",
  },
  label:{
    type: String,
  },
  modelValue: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "Your text here...",
  },
  isRequired: Boolean,
  disabled: {
    type: Boolean,
    default: false,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Number,
    default: 5,
  },
  success: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
  toolTipHeading: {
    type: String,
    default: '',
  },
  toolTipDescription: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(["update:modelValue"])

const localValue = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== localValue.value) {
      localValue.value = newVal
    }
  }
)

watch(localValue, (newVal) => {
  emit("update:modelValue", newVal)
})

const statusClass = computed(() => {
  if (props.success) return "is-valid"
  if (props.error) return "is-invalid"
  return ""
})

onMounted(() => {
  setMaterialInput()
})
</script>